import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { InvalidScopeError } from './errors';
import { DEFAULT_INJECTION_CONTEXT } from './injection-context';
export var ModuleRef = /*#__PURE__*/function () {
  function ModuleRef(_module) {
    _classCallCheck(this, ModuleRef);

    this._module = _module;
  }

  _createClass(ModuleRef, [{
    key: "container",
    get: function get() {
      return this._module.container;
    }
  }, {
    key: "get",
    value: function get(token) {
      var provider = this._module.resolveToken(token);

      if (provider == null) {
        throw new Error('Provider null');
      }

      if (provider.isTransient) {
        throw new InvalidScopeError(token);
      }

      return provider.getInstance(DEFAULT_INJECTION_CONTEXT);
    }
  }]);

  return ModuleRef;
}();